module.exports = __webpack_public_path__ + "static/media/azca hamza asif signature png white.1640a67d.png";